import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  padding: 3px;
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
  border-top: 2px solid rgba(0, 0, 0, 0.1);
`;

export const StyledButtonWrap = styled.div`
  flex: 1 1;
  text-align: center;
`;

export const StyledButton = styled.button`
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  background-color: #6200ea;
  color: #fff;
  border-color: #6200ea;
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;

  &:disabled {
    color: rgba(0, 0, 0, 0.6);
    background: rgba(0, 0, 0, 0.05);
    cursor: not-allowed;
  }
`;

export const StyledWrapper = styled.div`
  flex: 1.5 1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 0;
  text-align: center;
`;

export const StyledPageInfo = styled.div`
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;
`;

export const StyledPageSizeSelect = styled.div`
  margin: 3px 10px;
`;

export const StyledInput = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  font-weight: 400;
  outline: none;
  width: 70px;
  text-align: center;
  margin: 0 10px;
`;

export const StyledSelect = styled.select`
  padding: 5px 7px;
  margin: 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  background: #fff;
  font-size: inherit;
  font-weight: 400;
  outline: none;
  color: inherit;
  touch-action: manipulation;

  option {
    display: block;
    min-height: 1.2em;
    padding: 0 2px 1px;
    font-weight: normal;
    white-space: nowrap;
  }
`;
